import type { CoastalWetlandsResponse, ModuleFull } from "../../../pages/activityBuilder/modules/coastalWetlands/coastalWetlandsTypes";
import { apiSlice, publicApiSlice, TagTypes } from "../../apiSlice";
import { includedPropList, includedT2PropList } from "../../../pages/activityBuilder/modules/coastalWetlands/coastalWetlands";
import { FEModules, FEModulesObj } from "../../../utils/moduleList";
import { prepareModulePayload, transformModuleResponse } from "./factories/moduleApiUtils";
import { createModuleGetApi, createModuleUpdateApi } from "./factories/createModuleApi";

// Define constants for the module
const MODULE_TYPE = "CoastalWetlands";
const TAG: TagTypes = "CoastalWetlands";
const TAG_DEFAULTS: TagTypes = "CoastalWetlandsDefaults";
const ENDPOINT = FEModulesObj[FEModules.CoastalWetlands].path;

const t2PercentageProps = ["pc_c_lost_after_excavation_t2"];
const transformResponse = (response: CoastalWetlandsResponse) => transformModuleResponse<CoastalWetlandsResponse, ModuleFull>({
  response,
  includedPropList,
  includedT2PropList,
})

const coastalWetlandsApiSlice = createModuleGetApi<ModuleFull>({
  apiSlice,
  path: ENDPOINT,
  moduleName: MODULE_TYPE,
  tag: TAG,
  tagDefaults: TAG_DEFAULTS,
  transformResponse,
})

const publicCoastalWetlandsApiSlice = createModuleGetApi<ModuleFull>({
  apiSlice: publicApiSlice,
  path: ENDPOINT,
  moduleName: MODULE_TYPE,
  tag: TAG,
  tagDefaults: TAG_DEFAULTS,
  transformResponse,
})

export const {
  useGetCoastalWetlandsQuery,
  useGetCoastalWetlandsDefaultsQuery,
} = coastalWetlandsApiSlice;

export const {
  useGetCoastalWetlandsQuery: usePublicGetCoastalWetlandsQuery,
  useGetCoastalWetlandsDefaultsQuery: usePublicGetCoastalWetlandsDefaultsQuery,
} = publicCoastalWetlandsApiSlice;


const transformUpdatePayload = (data: ModuleFull, activityId: number) => prepareModulePayload({
  moduleData: data.module,
  tiertwoData: data.tiertwo,
  t2PercentageProps,
  activityId
})

const mutationApiSlice = createModuleUpdateApi<ModuleFull, CoastalWetlandsResponse>({
  apiSlice,
  path: ENDPOINT,
  moduleName: MODULE_TYPE,
  tag: TAG,
  tagDefaults: TAG_DEFAULTS,
  transformUpdatePayload,
})

export const {
  useUpdateCoastalWetlandsMutation,
} = mutationApiSlice;